import $ptBR from '../traducao/pt-br.js'
import $enEN from '../traducao/en-en.js'
import $esES from '../traducao/es-es.js'

window._traducao = function (local, texto) {
	switch ($sessao.getLang()) {
		case 'pt-br':
			return $ptBR[local][texto] + ''
			break
		case 'en-en':
			return $enEN[local][texto] + ''
			break
		case 'es-py':
			return $esES[local][texto] + ''
			break
	}
}
